import { render } from "./newsMs.vue?vue&type=template&id=7eab7e01"
import script from "./newsMs.vue?vue&type=script&lang=js"
export * from "./newsMs.vue?vue&type=script&lang=js"

import "./newsMs.vue?vue&type=style&index=0&id=7eab7e01&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__